<div class="container-login100">
    <div class="wrap-login100 col-md-9">
        <div class="row">
            <div class="col-md-3">
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <form class="login100-form validate-form">
                    <span class="login100-form-title"
                        style="color: #ffcc00; font-size: 22pt; text-transform: capitalize;">OOPS!<br> PAGE NOT FOUND.
                    </span>
                    <div class="text-center p-t-12">We could not find the page you were looking for. Meanwhile, you may
                        return to
                        <a class="txt2" href="/dashboard">
                            Dashboard
                        </a>
                    </div>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3">
            </div>
        </div>
    </div>
</div>